import { applyMiddleware, createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import rootReducer from "./rootReducer";
import thunk from 'redux-thunk'
import { persistStore, persistReducer } from "redux-persist";
import sessionStorage from 'redux-persist/es/storage/session';

const persistConfig = {
  key: "root",
  //storage
  storage:sessionStorage
};
const persistedReducer = persistReducer(persistConfig, rootReducer);
const store = createStore(
  persistedReducer,
  composeWithDevTools(applyMiddleware(thunk))
);

export default store;
export const persistor = persistStore(store);
